import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import css from './CloneMenuComponent.module.css';
import { availableDishesActions } from "../../../store/slices/menu-slices";
import { availableDishesService } from "../../../services/menu-services/availableDishes.service";


const CloneMenuComponent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { availableDishesArray, dataOfDay } = useSelector(store => store.availableDishes);

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm();

    const [cloning, setCloning] = useState(false); // щоб знати коли відбувається клонування

    const submit = async (data) => {
        if (!data?.date || data.date === dataOfDay) {
            toast.warning('Invalid or same date selected');
            return;
        }

        try {
            setCloning(true);

            // 1. Отримуємо список страв з обраної дати
            await dispatch(availableDishesActions.getAllAvailableDishes({ currentData: data.date }));

            // ⚠️ Важливо: очікуємо оновлення availableDishesArray в useEffect
        } catch (error) {
            console.error("Error fetching dishes to clone:", error);
            toast.error("Error fetching dishes");
        }
    };

    const updateDishesData = async () => {
        try {
            if (availableDishesArray.length > 0 && cloning) {
                const selectedData = availableDishesArray.map((obj) => ({
                    dishId: obj.dishId || obj.dish?.id, // підтримка обох варіантів
                    date: dataOfDay,
                }));

                await availableDishesService.updateByDateOfDay(dataOfDay, selectedData);
                dispatch(availableDishesActions.changeTrigger());
                toast.success("Menu cloned successfully");
            }
        } catch (error) {
            console.error("Error updating dishes:", error);
            toast.error("Error cloning menu");
        } finally {
            setCloning(false); // скидаємо прапорець
        }
    };

    useEffect(() => {
        if (cloning && availableDishesArray.length > 0) {
            updateDishesData();
        }
    }, [availableDishesArray]);

    return (
        <section className={css.wrap}>
            <form onSubmit={handleSubmit(submit)} className={css.form}>
                <label className={css.label}>{t('Clone-menu-from')}</label>
                <input
                    type="date"
                    {...register('date', { required: true })}
                    className={`${css.input} ${errors.date ? css.inputError : ''}`}
                />
                {errors.date && <p className={css.error}>{t('Date is required')}</p>}

                <button type="submit" disabled={isSubmitting} className={css.button}>
                    {isSubmitting ? 'Cloning...' : 'Ok'}
                </button>
            </form>
        </section>
    );
};

export { CloneMenuComponent };
